"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualConnectionTableTypeIcon = void 0;
const tslib_1 = require("tslib");
const catalog_icons_1 = require("@tableau/catalog-icons");
const react_1 = tslib_1.__importDefault(require("react"));
function VirtualConnectionTableTypeIcon(props) {
    if (props.isExtracted) {
        return react_1.default.createElement(catalog_icons_1.SvgVirtualConnectionTableExtract, null);
    }
    else {
        return react_1.default.createElement(catalog_icons_1.SvgVirtualConnectionTable, null);
    }
}
exports.VirtualConnectionTableTypeIcon = VirtualConnectionTableTypeIcon;
//# sourceMappingURL=VirtualConnectionTableTypeIcon.js.map